export default __webpack_public_path__ + "assets/10d.0fa0c57a.svg";